export default __webpack_public_path__ + "static/media/logo.5a317dc0.png";